import { DependencyList, EffectCallback, useEffect, useRef } from 'react';

const useDidMountEffect = (effect: EffectCallback, deps?: DependencyList) => {
  const mounted = useRef(false);

  useEffect(() => {
    if (!mounted.current) {
      mounted.current = true;
      return;
    }

    effect();
  }, deps);
};

export default useDidMountEffect;
